<script setup lang="ts">
import { useUiStore } from '@/stores/ui';
import Icon from '@/shared/icon/Icon.vue';

const ui = useUiStore();
const iconFor = (kind: string) => (kind === 'success' ? 'check' : kind === 'error' ? 'alert-triangle' : 'info');
</script>

<template>
  <Teleport to="body">
    <div class="toast-host">
      <TransitionGroup name="item">
        <div v-for="t in ui.toasts" :key="t.id" class="toast" role="status">
          <Icon :name="iconFor(t.kind)" :style="t.kind === 'error' ? 'color:var(--st-error)' : ''" />
          <span class="grow">{{ t.text }}</span>
          <button
            v-if="t.actionLabel"
            class="t-action"
            @click="t.onAction?.(); ui.dismissToast(t.id)"
          >
            {{ t.actionLabel }}
          </button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped>
.toast-host {
  position: fixed;
  left: 0;
  right: 0;
  bottom: calc(72px + var(--safe-bottom));
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  padding: 0 12px;
  z-index: 60;
  pointer-events: none;
}
.toast-host .toast {
  position: static;
  pointer-events: auto;
}
</style>
